import { datadogRum } from '@datadog/browser-rum';
import { DatadogLogger } from './datadog-logger.helper';
import { LogType } from '../types/logType';

const RESERVED_CONTEXT_KEYS = ['status', 'message'];

// Single call site for "this happened" telemetry — sends to RUM (as a
// queryable action/error, visible in the Explorer, not just replay video)
// and to Logs (existing DatadogLogger pipeline), so a screen/error is never
// only findable by watching a session replay.
export function reportEvent(
  name: string,
  context: Record<string, unknown>,
  type: LogType = LogType.INFO,
): void {
  if (process.env.NODE_ENV !== 'production') {
    // @datadog/browser-logs' assembly step merges this context object AFTER
    // its own fields, so a context key literally named `status` silently
    // overwrites the log level (a routine Incode "capture" state showing up
    // as Datadog status:critical) and one named `message` replaces the event
    // name (LIVENESS_WRAPPER_ERROR showed up as its raw error text). Caught
    // here in dev/test only; never throw in prod, per the try/catches below.
    RESERVED_CONTEXT_KEYS.forEach((key) => {
      if (key in context) {
        // eslint-disable-next-line no-console
        console.error(`reportEvent('${name}', ...): context must not use the reserved key "${key}" — it silently overwrites the Datadog log ${key === 'status' ? 'severity' : 'message'}. Rename it (e.g. "${key === 'status' ? 'incodeStatus' : 'errorMessage'}").`);
      }
    });
  }

  // Each channel gets its own guard — a RUM SDK failure must not also
  // swallow the Logs write (and vice versa).
  try {
    if (type === LogType.ERROR) {
      datadogRum.addError(name, context);
    } else {
      datadogRum.addAction(name, context);
    }
  } catch {
    // Datadog must never break the liveness flow
  }
  try {
    DatadogLogger.Log(name, context, type);
  } catch {
    // Datadog must never break the liveness flow
  }
}
